export function encode(value, noEncode = false) {
  const stringified = JSON.stringify({ o: value });
  return noEncode ? stringified : encodeURIComponent(stringified);
}

export function decode(value, noDecode = false) {
  if (value === undefined) return;
  const decoded = noDecode ? value : decodeURIComponent(value);
  try {
    const parsed = JSON.parse(decoded);
    return parsed && parsed.o ? parsed.o : undefined;
  } catch (err) {
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/tools/coding.js